/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import { number } from 'prop-types';
import { useSelector } from 'react-redux';
import style from './LinearProgressBar.module.css';
import { getBrand } from '../../../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import byoTheme from './BYOTheme';

const LinearProgressBar = ({ total, selected }) => {
    useStyles(style);

    const brandData = useSelector(getBrand);
    const brandCode = brandData?.code;

    // default color assigned when no brand code found
    const {
        progressColorError = '#DF3030',
        progressColorPending = '#C8E9F1',
        progressColorSelected = '#512C1C',
    } = byoTheme[brandCode] || {};

    const percentageSelected = Math.min((selected / total) * 100, 100);
    const percentageError = selected > total ? ((selected - total) / total) * 100 : 0;

    return (
        <div
            className={style.container}
            style={{
                backgroundColor: progressColorPending,
            }}
        >
            <div
                className={`${style.progress} ${percentageError > 0 ? style.selected : ''}`}
                style={{
                    width: `${percentageSelected}%`,
                    backgroundColor: progressColorSelected,
                }}
            />
            {percentageError > 0 && (
                <div
                    className={`${style.progress} ${style.error}`}
                    style={{
                        width: `${percentageError}%`,
                        backgroundColor: progressColorError,
                    }}
                />
            )}
        </div>
    );
};

LinearProgressBar.propTypes = {
    total: number,
    selected: number.isRequired,
};

LinearProgressBar.defaultProps = {
    total: 0,
};

export default LinearProgressBar;
